// Copyright (c) Mysten Labs, Inc.
// Modifications Copyright (c) 2024 IOTA Stiftung
// SPDX-License-Identifier: Apache-2.0

export enum ObjectViewMode {
    List,
    SmallThumbnail,
    Thumbnail,
}
